import { makeStyles, tokens } from '@fluentui/react-components';
export var useStyles = makeStyles({
    spinnerContainer: {
        justifyContent: 'center',
        display: 'flex',
        width: '-webkit-fill-available',
        height: '100vh',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1000002,
        backgroundColor: tokens.colorNeutralBackground1,
    },
    copilotSection: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'stretch', // Ensure children take full width
    },
});
//# sourceMappingURL=CopilotAppPage.styles.js.map